import { Stack, Typography } from '@mui/material';
import { PublicService, getServiceDurationMinutes } from '../../types';
import { PublicServiceItem } from './PublicServiceItem';
import { useIntlTranslations } from '@libs/intl/intl.hooks';
import type { SupportedCurrency } from '@features/currency/currency.types';

type Props = {
  services: PublicService[];
  selectedService: PublicService | null;
  onSelect: (s: PublicService) => void;
  preferredCurrency: SupportedCurrency;
};

const StepServiceSelect = ({ services, selectedService, onSelect, preferredCurrency }: Props) => {
  const { t } = useIntlTranslations();

  return (
    <Stack spacing={1.5}>
      <Typography variant="subtitle1" fontWeight={700} color="text.primary">
        {t('StepServiceSelect.title')}
      </Typography>
      {services.map(service => {
        const isSelected = selectedService?.id === service.id;
        const durationMin = getServiceDurationMinutes(service.blocks);
        const displayName = service.publicName || service.serviceName;
        const hasDescription = !!service.publicDescription;

        return (
          <PublicServiceItem
            key={service.id}
            isSelected={isSelected}
            durationMin={durationMin}
            displayName={displayName}
            hasDescription={hasDescription}
            service={service}
            onSelect={onSelect}
            preferredCurrency={preferredCurrency}
          />
        );
      })}
    </Stack>
  );
};

export default StepServiceSelect;
